var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.widget)?_c('custom-widget-form',{attrs:{"title":_vm.$t('custom_widgets.edit_custom_widget'),"id-site":_vm.idSite,"current-widget":_vm.widget,"save":_vm.save}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }